
export enum LoggedState {
    UNLOGGED, LOGGED, POSTREGISTER
}
